module.exports = __webpack_public_path__ + "74845cbe18ca58c46ce0e186c0a6712e.jpg";